import axios from 'axios';
import JustificationFile from '@/domain/contract-history/entity/justification-file.entity';

export default class JustificationFileService {
  public static getById(justificationFileId: string): Promise<JustificationFile> {
    return axios.get(`/api/v1/justifications/${justificationFileId}/file`)
      .then(({ data }) => new JustificationFile(data));
  }
}
